"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageTable = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var UsageTableBase_1 = require("./UsageTableBase");
var DailySplitTables = function (_a) {
    var data = _a.data, rest = __rest(_a, ["data"]);
    var _b = (0, core_1.useComponents)(), Row = _b.Row, Col = _b.Col, Heading3 = _b.Heading3;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var dataBeforeMidday = data.filter(function (_a) {
        var date = _a.date;
        return (0, date_fns_1.getHours)(date) < 12;
    });
    var dataAfterMidday = data.filter(function (_a) {
        var date = _a.date;
        return (0, date_fns_1.getHours)(date) >= 12;
    });
    return (react_1.default.createElement(Row, { isNested: true, "data-testid": "daily-usage-tables" },
        dataBeforeMidday.length === 0 ? null : (react_1.default.createElement(Col, { medium: 6 },
            react_1.default.createElement(Heading3, { as: "h2" }, copy('dailyTableBeforeMiddayLabel')),
            react_1.default.createElement(UsageTableBase_1.UsageTableBase, __assign({ data: dataBeforeMidday }, rest)))),
        dataAfterMidday.length === 0 ? null : (react_1.default.createElement(Col, { medium: 6 },
            react_1.default.createElement(Heading3, { as: "h2" }, copy('dailyTableAfterMiddayLabel')),
            react_1.default.createElement(UsageTableBase_1.UsageTableBase, __assign({ data: dataAfterMidday }, rest))))));
};
var TableWrapper = function (_a) {
    var children = _a.children;
    var Disclosure = (0, core_1.useComponents)().Disclosure;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var width = (0, utils_1.useWindowDimensions)().width;
    var tableInDisclosure = width < 768;
    return tableInDisclosure ? (react_1.default.createElement(Disclosure, { title: copy('tableDisclosure'), "data-testid": "usage-table-disclosure" }, children)) : (react_1.default.createElement("div", null, children));
};
var UsageTable = function (_a) {
    var datePeriod = _a.datePeriod, rest = __rest(_a, ["datePeriod"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(TableWrapper, null, datePeriod === 'daily' ? (react_1.default.createElement(DailySplitTables, __assign({ datePeriod: datePeriod }, rest))) : (react_1.default.createElement(UsageTableBase_1.UsageTableBase, __assign({ datePeriod: datePeriod }, rest))))));
};
exports.UsageTable = UsageTable;
